export default "__VITE_ASSET__CMZ8Ajf9__"